import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { API_VESSELS_LIST } from 'utils/apiList'

const getVesselsDetail = createAsyncThunk(
  'vesselsList/list',
  async ({ id }, { rejectWithValue, getState }) => {
    try {
      const { auth } = getState()
      let config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.token}`,
        },
      }
      const { data } = await axios.get(`${API_VESSELS_LIST}/${id}`, config)
      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

export { getVesselsDetail }
